<template>
  <v-tooltip id="tooltip-p-stop-watch" :class="$vuetify.breakpoint.smAndDown ? 'tooltip-100' : ''" v-if="this.durationStopWatch.active" bottom>
    <v-btn v-if="!$vuetify.breakpoint.smAndDown" slot="activator" light large color="#ccc" id="btnDuration" @click="closeClick">
      <v-progress-circular v-if="loadingStopwatch" indeterminate color="primary"></v-progress-circular>
      <span v-else> {{durationStopWatch.id_text | formatAbbreviation(30)}} - {{time}}</span>
      <v-icon class="ml-1" right color="red">stop</v-icon>
    </v-btn>
    <v-btn style="padding: 0; width: 100%;" v-else slot="activator" light large color="#ccc" id="btnDuration" @click="closeClick">
      {{durationStopWatch.id_text | formatAbbreviation(20)}} - {{time}}
      <v-icon color="red">stop</v-icon>
    </v-btn>
    <span >{{durationStopWatch?durationStopWatch.id_text:''}}</span>
  </v-tooltip>
</template>

<style scoped>
  .tooltip-100{
    width: 96% !important;  
  }

  #btnDuration {
    font-size: 14px;
    text-transform: capitalize;
    margin-left: 5px !important;
    width: 98% !important;  
  }
</style>

<script>
  /* eslint-disable eqeqeq */
  import moment from 'moment'
  import momentDurationFormatSetup from 'moment-duration-format'

  momentDurationFormatSetup(moment)
  export default {
    name: 'PStopWatch',
    components: {},
    data () {
      return {
        // oldDurationStopWatch variavel usada para saber te tinha algum tempo rodando
        oldDurationStopWatch: {},
        active: 0,
        tipo: 0,
        hour: 0,
        minute: 0,
        second: 0,
        interval: '',
        time: '',
        loadingStopwatch: false,
        showDuration: false,
        change: false,
        setDurationTimerInterval: ''
      }
    },
    created () {
      this.oldDurationStopWatch = JSON.parse(JSON.stringify(this.durationStopWatch))
      this.startTime()
    },
    sockets: {
      changeStopWatch (item) {
        this.$store.commit('stopWatch/change_values', item)
      },
      // Reset usado para resetar os valores quando clica na mesma tarefa e o tempo deveria parar, mas não para pelo watch.
      resetStopWatch () {
        this.$store.commit('stopWatch/reset_values')
      },
      changeCompanyParams (params) {
        // Muda os parametros em todas as abas abertas
        this.$auth.user().company.params = JSON.stringify(params)
      }
    },
    methods: {
      startTime () {
        // limpa o ultimo interval para iniciar o novo
        clearInterval(this.setDurationTimerInterval)
        this.setDurationTimerInterval = setInterval(() => {
          this.time = moment.duration(moment().diff(moment(this.durationStopWatch.begin))).format('hh:mm:ss', {
            trim: false
          })
        }, 1000)
      },
      closeClick () {
        let values = {httpDB: true, active: false}
        this.$store.commit('stopWatch/change_values', values)
        this.$socket.emit('generalEvent', {
          data: Object.assign(values, {httpDB: false}),
          responseEvent: 'changeStopWatch',
          room: `user${this.$auth.user().id}`
        })
      },
      start (item) {
        this.loadingStopwatch = true
        Object.assign(item, {user_id: this.$auth.user().id, company_id: this.$auth.user().company_id})
        // Tira o id pois quando tem uma tarefa já rodando, ele já vem com valor
        delete item.id
        this.$http.post('api/task_duration', item).then(
          res => {
            this.time = moment.duration(moment().diff(moment(this.durationStopWatch.begin))).format('hh:mm:ss', {
              trim: false
            })
            // Passa o httpDB false para que não seja alterado nada, apenas coloca o id
            Object.assign(item, {id: res.body.id, httpDB: false})
            this.$store.commit('stopWatch/change_values', item)
            // Inicia o tempo em outras abas
            this.$socket.emit('generalEvent', {
              data: item,
              responseEvent: 'changeStopWatch',
              room: `user${this.$auth.user().id}`
            })
            this.loadingStopwatch = false
            this.$store.commit('snackbar/change_values', {
              text: 'Duração iniciada!',
              color: 'success',
              dialog: true
            })
          },
          err => {
            console.log(err)
            this.$store.commit('stopWatch/reset_values')
            this.loadingStopwatch = false
          }
        )
      },
      // Existe o id pois caso o usuário altere duas tarefas que deveriam contar o tempo muito rapido, o id acaba sendo zerado
      close (id = this.durationStopWatch.id, resetValues = true) {
        this.loadingStopwatch = true
        let values = {id: id, active: false, end: moment().format('YYYY-MM-DD HH:mm:ss')}
        this.$http.put('api/task_duration/' + values.id, values).then(
          (res) => {
            let values = res.body
            values['type'] = 'add'
            if (resetValues) this.$store.commit('stopWatch/reset_values')
            // adiciona o shift pois ele faz adicionar o ergistro na primeira linha
            values['shift'] = true
            // Manda o evento para recalcular as durações na tela de consulta de tarefas, usado o general pois o recalcular é participar das tarefas
            this.$socket.emit('generalDetailsEvent', {
              data: values,
              notBroadcast: true,
              details: 'durations',
              responseEvent: 'addSocketDetails',
              // Usado o task para pegar a empresa da tarefa pois a tarefa pode ser de alguma parceria
              room: `tasks${values.task_id}_manage`
            })
            // Emissão de evento para adição de detalhes
            this.loadingStopwatch = false
            this.$store.commit('snackbar/change_values', {
              text: 'Duração salva com sucesso!',
              color: 'success',
              dialog: true
            })
          },
          err => {
            alert('Erro! Falha ao enviar a requisição.')
            console.log(err)
            this.loadingStopwatch = false
          }
        )
      }
    },
    computed: {
      durationStopWatch () {
        return this.$store.getters[`stopWatch/values`] || ''
      }
    },
    destroyed () {
      clearInterval(this.setDurationTimerInterval)
    },
    watch: {
      durationStopWatch: {
        deep: true,
        // handler (val, oldVal) oldVal não estava buscando os valores antigos, sendo necessario oldDurationStopWatch
        handler (val) {
          // criado a variavel durationStopWatch, pois o val estava mudava de valor no meio do processo quando era de começar outra tarefa com uma já rodando
          let durationStopWatch = JSON.parse(JSON.stringify(val))
          if (durationStopWatch.httpDB) {
            this.active = durationStopWatch.active
            // Se o valor estiver ativo, caso não esteja ativo fecha o tempo
            if (durationStopWatch.active) {
              // verifica se a tarefa é a msma, pois significa que o usuário clicou na mesma tarefa, fechando ela
              if (this.oldDurationStopWatch.task_id == durationStopWatch.task_id) {
                this.close(this.oldDurationStopWatch.id)
                // para o tempo nas outras abas
                this.$socket.emit('generalEvent', {
                  responseEvent: 'resetStopWatch',
                  room: `user${this.$auth.user().id}`
                })
              } else {
                // caso a tarefa seja diferente, se antes já tiver uma tarefa rodando, para ela pra começar a clicada atualmente
                if (this.oldDurationStopWatch.active) {
                  // Coloca false para o reset no close para das a impressão pro usuário de que o tempo contou instantaneo
                  this.close(this.oldDurationStopWatch.id, false)
                  setTimeout(() => {
                    this.start(JSON.parse(JSON.stringify(durationStopWatch)))
                  }, 1500)
                  // Caso a tarefa antiga não esteja ativa, apenas da inicio a tarefa clicada
                } else this.start(JSON.parse(JSON.stringify(durationStopWatch)))
              }
            } else {
              this.close(durationStopWatch.id)
            }
          // caso tenha vindo do tempo real como ativo falso, so reseta os valores caso tenha algum ativo
          } else if (this.oldDurationStopWatch.active && !durationStopWatch.active) {
            this.$store.commit('stopWatch/reset_values')
          }
          this.oldDurationStopWatch = JSON.parse(JSON.stringify(durationStopWatch))
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/PStopWatch.vue